const VEHICLES_FILTER_NAME = "gama.vehicles.filter";
const CUSTOMERS_FILTER_NAME = "gama.customers.filter";

export const removeFilters = () => {
  localStorage.removeItem(VEHICLES_FILTER_NAME);
  localStorage.removeItem(CUSTOMERS_FILTER_NAME);
};